import ScheduleReport from './ScheduleReport';
import './scheduleReport.scss'

export default ScheduleReport;